import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data4_3_2 } from './data4';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";

const { MonthPicker, RangePicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

function numChange(text = '0') {

    let html = Number(text || '0') < 0 ?
        <span style={{ color: "red" }}>
            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
        </span>
        :
        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return html;

}

function numConvert(num = 0) {
    num = Number(num || "0")
    return num
};

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loadingSave: false,
            loading: true,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const totalName = ['m_this_RN', 'm_this_REV', 'm_last_RN', 'm_last_REV', 'y_this_RN', 'y_this_REV', 'y_last_RN', 'y_last_REV'];
        for (let i = 0; i < totalName.length; i++) {
            data[10][totalName[i]] = data.reduce((a, b, index) => {
                if (index < 10) {
                    a += numConvert(b[totalName[i]]);
                }
                return a
            }, 0);
            data[10][totalName[i]] = data[10][totalName[i]].toFixed(2);
        }

        for (let i = 0; i < data.length; i++) {
            data[i].m_this_ADR = (numConvert(data[i].m_this_RN) == 0 ? 0 : numConvert(data[i].m_this_REV) / numConvert(data[i].m_this_RN)).toFixed(2);
            data[i].m_last_ADR = (numConvert(data[i].m_last_RN) == 0 ? 0 : numConvert(data[i].m_last_REV) / numConvert(data[i].m_last_RN)).toFixed(2);
            data[i].m_ratio_RN = (numConvert(data[i].m_this_RN) - numConvert(data[i].m_last_RN)).toFixed(2);
            data[i].m_RN_percent = (numConvert(data[i].m_last_RN) == 0 ? 0 : numConvert(data[i].m_ratio_RN) / numConvert(data[i].m_last_RN)).toFixed(3);
            data[i].m_ratio_ADR = (numConvert(data[i].m_this_ADR) - numConvert(data[i].m_last_ADR)).toFixed(2);
            data[i].m_ADR_percent = (numConvert(data[i].m_last_ADR) == 0 ? 0 : numConvert(data[i].m_ratio_ADR) / numConvert(data[i].m_last_ADR)).toFixed(3);
            data[i].m_ratio_REV = (numConvert(data[i].m_this_REV) - numConvert(data[i].m_last_REV)).toFixed(2);
            data[i].m_REV_percent = (numConvert(data[i].m_last_REV) == 0 ? 0 : numConvert(data[i].m_ratio_REV) / numConvert(data[i].m_last_REV)).toFixed(3);

            data[i].y_this_ADR = (numConvert(data[i].y_this_RN) == 0 ? 0 : numConvert(data[i].y_this_REV) / numConvert(data[i].y_this_RN)).toFixed(2);
            data[i].y_last_ADR = (numConvert(data[i].y_last_RN) == 0 ? 0 : numConvert(data[i].y_last_REV) / numConvert(data[i].y_last_RN)).toFixed(2);
            data[i].y_ratio_RN = (numConvert(data[i].y_this_RN) - numConvert(data[i].y_last_RN)).toFixed(2);
            data[i].y_RN_percent = (numConvert(data[i].y_last_RN) == 0 ? 0 : numConvert(data[i].y_ratio_RN) / numConvert(data[i].y_last_RN)).toFixed(3);
            data[i].y_ratio_ADR = (numConvert(data[i].y_this_ADR) - numConvert(data[i].y_last_ADR)).toFixed(2);
            data[i].y_ADR_percent = (numConvert(data[i].y_last_ADR) == 0 ? 0 : numConvert(data[i].y_ratio_ADR) / numConvert(data[i].y_last_ADR)).toFixed(3);
            data[i].y_ratio_REV = (numConvert(data[i].y_this_REV) - numConvert(data[i].y_last_REV)).toFixed(2);
        }

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data4_3_2);
        let data = JSON.parse(dataBegin);
        fetch(`/_4_3_4_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.data && x.data.length > 0) {
                if (x.data.length > 10) {
                    data = [...x.data.filter((v, i) => i <= 9), x.data[x.data.length - 1]];
                } else {
                    data = x.data;
                }
            }
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_3_4', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_3_4', 1.5, '4.33', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth - 3450 > 300 ? document.body.offsetWidth - 3450 : 300;
        const columns = [{
            title: <div>Top 10 Group（Biz Group & Leisure Group）<br /> 团队客户前十位</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width,
            render: (text, record, index) => {
                if (index != 10) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    let data = this.state.data;
                                    data[index].name = e.target.value || "";
                                    data[index].name_code = e.target.value || "";
                                    this.setState({ data });
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                            {text}
                        </div>
                    )
                }

            }
        }, {
            title: 'MTD 月累计',
            align: "center",
            children: [{
                align: "center",
                title: 'MTD Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div>R/Ns 间夜</div>,
                    dataIndex: 'm_this_RN',
                    key: 'm_this_RN',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - This Year 本年当月实际数', 'R/Ns 间夜'];
                        if (index != 10) {
                            return (
                                <Compared data={{ index, key: 'm_this_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('m_this_RN', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'm_this_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>ADR 平均房价</div>,
                    dataIndex: 'm_this_ADR',
                    key: 'm_this_ADR',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - This Year 本年当月实际数', 'ADR 平均房价'];
                        return (
                            <Compared data={{ index, key: 'm_this_ADR', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'm_this_REV',
                    key: 'm_this_REV',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - This Year 本年当月实际数', 'REV 收益'];
                        if (index == 10) {
                            return (
                                <Compared data={{ index, key: 'm_this_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding table-color-footer `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'm_this_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('m_this_REV', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'MTD Actual - Last Year 去年当月实际数',
                width: 450,
                children: [{
                    title: <div>R/Ns 间夜</div>,
                    dataIndex: 'm_last_RN',
                    key: 'm_last_RN',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - Last Year 去年当月实际数', 'R/Ns 间夜'];
                        if (index == 10) {
                            return (
                                <Compared data={{ index, key: 'm_last_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding table-color-footer `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'm_last_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('m_last_RN', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }
                    }
                }, {
                    title: <div>ADR 平均房价</div>,
                    dataIndex: 'm_last_ADR',
                    key: 'm_last_ADR',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - Last Year 去年当月实际数', 'ADR 平均房价'];
                        return (
                            <Compared data={{ index, key: 'm_last_ADR', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'm_last_REV',
                    key: 'm_last_REV',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - Last Year 去年当月实际数', 'REV 收益'];
                        if (index == 10) {
                            return (
                                <Compared data={{ index, key: 'm_last_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding table-color-footer `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'm_last_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('m_last_REV', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }
                    }
                }]
            }, {
                align: "center",
                title: 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>R/Ns 间夜</div>,
                    dataIndex: 'm_ratio_RN',
                    key: 'm_ratio_RN',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'R/Ns 间夜'];
                        return (
                            <Compared data={{ index, key: 'm_ratio_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>% 百分比</div>,
                    dataIndex: 'm_RN_percent',
                    key: 'm_RN_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        let html = null;
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                        return (
                            <Compared data={{ index, key: 'm_RN_percent', title, sqlName: "_4_3_4", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${index == 10 ? 'table-color-footer' : ''}`} style={{ textAlign: "right", padding: "5px" }}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>ADR  平均房价</div>,
                    dataIndex: 'm_ratio_ADR',
                    key: 'm_ratio_ADR',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'ADR 平均房价'];
                        return (
                            <Compared data={{ index, key: 'm_ratio_ADR', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>% 百分比</div>,
                    dataIndex: 'm_ADR_percent',
                    key: 'm_ADR_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        let html = null;
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                        return (
                            <Compared data={{ index, key: 'm_ADR_percent', title, sqlName: "_4_3_4", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${index == 10 ? 'table-color-footer' : ''}`} style={{ textAlign: "right", padding: "5px" }}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'm_ratio_REV',
                    key: 'm_ratio_REV',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'REV 收益'];
                        return (
                            <Compared data={{ index, key: 'm_ratio_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>% 百分比</div>,
                    dataIndex: 'm_REV_percent',
                    key: 'm_REV_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分'];
                        let html = null;
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                        return (
                            <Compared data={{ index, key: 'm_REV_percent', title, sqlName: "_4_3_4", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${index == 10 ? 'table-color-footer' : ''}`} style={{ textAlign: "right", padding: "5px" }}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }],
        }, {
            title: 'YTD 本年累计',
            align: "center",
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 本年累计实际数',
                width: 450,
                children: [{
                    title: <div>R/Ns 间夜</div>,
                    dataIndex: 'y_this_RN',
                    key: 'y_this_RN',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Actual - This Year 本年累计实际数', 'R/Ns 间夜'];
                        if (index != 10) {
                            return (
                                <Compared data={{ index, key: 'y_this_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('y_this_RN', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'y_this_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>ADR 平均房价</div>,
                    dataIndex: 'y_this_ADR',
                    key: 'y_this_ADR',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Actual - This Year 本年累计实际数', 'ADR 平均房价'];
                        return (
                            <Compared data={{ index, key: 'y_this_ADR', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'y_this_REV',
                    key: 'y_this_REV',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Actual - This Year 本年累计实际数', 'REV 收益'];
                        if (index == 10) {
                            return (
                                <Compared data={{ index, key: 'y_this_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding table-color-footer `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'y_this_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('y_this_REV', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'YTD Actual - Last Year 去年累计实际数',
                width: 450,
                children: [{
                    title: <div>R/Ns 间夜</div>,
                    dataIndex: 'y_last_RN',
                    key: 'y_last_RN',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Actual - Last Year 去年累计实际数', 'R/Ns 间夜'];
                        if (index == 10) {
                            return (
                                <Compared data={{ index, key: 'y_last_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding table-color-footer `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'y_last_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('y_last_RN', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }
                    }
                }, {
                    title: <div>ADR 平均房价</div>,
                    dataIndex: 'y_last_ADR',
                    key: 'y_last_ADR',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Actual - Last Year 去年累计实际数', 'ADR 平均房价'];
                        return (
                            <Compared data={{ index, key: 'y_last_ADR', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'y_last_REV',
                    key: 'y_last_REV',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Actual - Last Year 去年累计实际数', 'REV 收益'];
                        if (index == 10) {
                            return (
                                <Compared data={{ index, key: 'y_last_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className={`table-padding table-color-footer `}>
                                        {numChange(text)}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'y_last_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={0}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('y_last_REV', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>R/Ns 间夜</div>,
                    dataIndex: 'y_ratio_RN',
                    key: 'y_ratio_RN',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'R/Ns 间夜'];
                        return (
                            <Compared data={{ index, key: 'y_ratio_RN', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>% 百分比</div>,
                    dataIndex: 'y_RN_percent',
                    key: 'y_RN_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        let html = null;
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                        return (
                            <Compared data={{ index, key: 'y_RN_percent', title, sqlName: "_4_3_4", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${index == 10 ? 'table-color-footer' : ''}`} style={{ textAlign: "right", padding: "5px" }}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>ADR  平均房价</div>,
                    dataIndex: 'y_ratio_ADR',
                    key: 'y_ratio_ADR',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'ADR  平均房价'];
                        return (
                            <Compared data={{ index, key: 'y_ratio_ADR', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>% 百分比</div>,
                    dataIndex: 'y_ADR_percent',
                    key: 'y_ADR_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        let html = null;
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                        return (
                            <Compared data={{ index, key: 'y_ADR_percent', title, sqlName: "_4_3_4", name: record.name, type: 'percent' }}>
                                <div className={`table-color ${index == 10 ? 'table-color-footer' : ''}`} style={{ textAlign: "right", padding: "5px" }}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>REV 收益</div>,
                    dataIndex: 'y_ratio_REV',
                    key: 'y_ratio_REV',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 本年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'REV 收益'];
                        return (
                            <Compared data={{ index, key: 'y_ratio_REV', title, sqlName: "_4_3_4", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 10 ? 'table-color-footer' : ''} `}>
                                    {numChange(text)}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }],
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_3_4" style={{ width: this.state.print ? 3800 : 'auto' }}>
                        <Row>4.3.3  Group（Biz Group & Leisure Group）团队客户 </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3750 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3750, y: 550 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_3">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-3/4-3-4.js